import { Dispatch, FC, ReactNode, SetStateAction, createContext, useEffect, useState } from 'react';
import { stored } from '../constants';
import { SortDirection } from '../componenents/Review/ReviewCasesTab/directionSortToggle/DirectionSortToggle';


export type CasesSortsType = {
    direction?: SortDirection;
}

interface SortsContext {
    setCasesSorts: Dispatch<SetStateAction<CasesSortsType>>;
    casesSorts: CasesSortsType;
};

export const SortsContext = createContext<SortsContext>(undefined as any);

interface Props {
    children: ReactNode;
}

export const SortsProvider: FC<Props> = ({ children }) => {
    const [casesSorts, setCasesSorts] = useState<CasesSortsType>({ direction: null });

    useEffect(() => {
        const reviewCasesSorts = localStorage.getItem(stored.reviewCasesSorts);
        if (reviewCasesSorts)
            setCasesSorts(JSON.parse(reviewCasesSorts));
    }, []);

    const value = {
        setCasesSorts,
        casesSorts
    }
    return <SortsContext.Provider value={value}>{children}</SortsContext.Provider>
}